import React from 'react'
import { Grid, Link } from '@mui/material';
import Card from '@mui/material/Card';
import { useSelector } from 'react-redux';
import {selectTopUpData} from '../../../../features/userInfo/topUpSlice'
import TopUpBankActive from './TopUpBankActive'
import TopUpBankInactive from './TopUpBankInactive'
import TopUpBankPending from './TopUpBankPending'
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Lottie from "lottie-react";
import smallLoadingAnimation from '../../../../icons/lottieAnimations/smallLoading.json'

const TopUpBank = () => 
{   
    const topUpData = useSelector(selectTopUpData)
    const navigate = useNavigate()

    React.useEffect(()=>{},[topUpData.isBankAccoutConfirmationPending])

    const useStyles = makeStyles({
        bankImage:{
            width:'60%',
            marginLeft:'20%'
        },
        card:{
            borderRadius:'20px',
            width:'45%', 
            boxShadow:'0 0 15px 5px #E5E7EA',
            '@media (max-width: 1024px)' : {width:'70%'},
            '@media (max-width: 899px)' : {width:'90%'}
        },
        imageGrid:{
            borderRadius:'20px',
            backgroundColor:topUpData.selectedBank.bankColor
        }
    })

    const classes = useStyles()

    return(
        <Grid container item md={12} xs={12} justifyContent={'center'} >
            <Card  className={classes.card}>
                
                <Grid container item  md={12} direction='row'>
                    <Grid container item md={3.5} justifyContent={'center'} direction={'column'} className={classes.imageGrid} > 
                        <img src={topUpData.selectedBank.bankImage} className={classes.bankImage} />
                    </Grid>
                    <Grid  container item md={8.5} pt={'5%'} pb={'5%'} justifyContent='center' sx={{'@media (max-width: 899px)' : {pl:'5%'}}} >
                        <Grid item md={6.5}>
                            <Grid container item md={2} xs={2} mt={-2} mb={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
                           {(topUpData.selectedBank.isActive === true && topUpData.selectedBank.isPending === false) && <TopUpBankActive bankData={topUpData.selectedBank}/>}
                           {(topUpData.selectedBank.isActive === false && topUpData.selectedBank.isPending === false) && <TopUpBankInactive/>}
                           {(topUpData.selectedBank.isActive === false && topUpData.selectedBank.isPending === true) && <TopUpBankPending/>}
                        </Grid>
                        <Grid container item md={6.5} xs={12} justifyContent={'center'}>
                            <Grid item md={4} xs={2}>
                                {topUpData.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true} width={'100px'}/>}
                            </Grid>    
                        </Grid>     
                    </Grid>            
                </Grid>
            </Card>
        </Grid>

    )
}
export default TopUpBank


// if(state.selectedBank.isActive === true && state.selectedBank.isPending === false)
// {
//     state.componentToDisplay = <TopUpBankActive bankData={action.payload}/>
// }
// else if(state.selectedBank.isActive === false && state.selectedBank.isPending === false)
// {
//     state.componentToDisplay = <TopUpBankInactive/>
// }
// else if(state.selectedBank.isActive === false && state.selectedBank.isPending === true)
// {
//     state.componentToDisplay = <TopUpBankPending/>
// }